import { ToastOptions } from 'ng2-toastr';

export class CustomToastOptions extends ToastOptions {
    animate = 'flyLeft';
    showCloseButton = true;
    positionClass = 'toast-top-left';
    toastLife = 2000;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/custom-toast-options.ts